export default __webpack_public_path__ + "static/media/1384.07377c56.png";